(function () {
	const header = () => {
		console.log("HEADER.JS LOADED");

		// Hover efekat
		$("[data-hover-opacity]").hover(
			function () {
				const id = $(this).data("hover-opacity");
				$(`[data-hover-opacity=${id}]`).addClass("opacity");
				$(this).removeClass("opacity");
			},
			function () {
				const id = $(this).data("hover-opacity");
				$(`[data-hover-opacity=${id}]`).removeClass("opacity");
			}
		);

		// Ako details-disclosure NIJE registrovan, registruj ga
		if (!customElements.get('details-disclosure')) {
			class DetailsDisclosure extends HTMLElement {
				connectedCallback() {
					const summary = this.querySelector('summary');
					const details = this.querySelector('details');

					if (summary && details) {
						summary.addEventListener('click', (e) => {
							e.preventDefault();
							const all = document.querySelectorAll('.header__account details');
							all.forEach((el) => {
								if (el !== details) el.removeAttribute('open');
							});
							details.toggleAttribute('open');
						});
					}
				}
			}
			customElements.define('details-disclosure', DetailsDisclosure);
		} else {
			// Ako već jeste, dodaj ručni klik fallback
			document.querySelectorAll('.header__account summary').forEach((summary) => {
				summary.addEventListener('click', (e) => {
					e.preventDefault();
					const details = summary.closest('details');
					const all = document.querySelectorAll('.header__account details');
					all.forEach((el) => {
						if (el !== details) el.removeAttribute('open');
					});
					details.toggleAttribute('open');
				});
			});
		}
	};

	// Reinit kada se učita nova sekcija (Shopify editor)
	document.addEventListener("shopify:section:load", header);

	// Pokreni odmah
	header();
})();
